import { useTranslation as useI18nTranslation } from 'react-i18next';
// 导入高阶组件 withTranslation
import { withTranslation } from 'react-i18next';
import i18next from '@/i18n';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import i18n from '@/i18n';

// 自定义的多语言 Hook，支持命名空间
// export const useTranslation = (namespace = "common") => {
//     const { t, i18n } = useI18nTranslation(namespace);

//     // 切换语言
//     const changeLanguage = (lng) => {
//         i18n.changeLanguage(lng);
//         localStorage.setItem("i18nextLng", lng);
//     };

//     // 获取当前语言
//     const getCurrentLanguage = () => {
//         return i18n.language;
//     };

//     // 检查是否为中文
//     const isChinese = () => {
//         return i18n.language === "zh";
//     };

//     // 检查是否为英文
//     const isEnglish = () => {
//         return i18n.language === "en";
//     };

//     // 切换命名空间
//     const changeNamespace = (ns) => {
//         i18n.changeLanguage(i18n.language, ns);
//     };

//     return {
//         t,
//         i18n,
//         changeLanguage,
//         getCurrentLanguage,
//         isChinese,
//         isEnglish,
//         changeNamespace,
//         language: i18n.language,
//     };
// };

const runsOnServerSide = typeof window === 'undefined';

export const useTranslation = (ns: string | string[], options?: Record<string, unknown>) => {
    const lng = i18next.language;
    ns = ns ? ns : 'common';

    // 从url中获取语言·
    // const lng = useParams()?.lng;

    // if (typeof lng !== "string") {
    //     throw new Error("useTranslations is only available inside /app/[lng]");
    // }

    // 如果是服务器
    if (runsOnServerSide && i18next.resolvedLanguage !== lng) {
        // 设置语言
        i18next.changeLanguage(lng);
    } else {
        // 如果是客户端

        const [activeLng, setActiveLng] = useState(i18next.resolvedLanguage);

        useEffect(() => {
            // 异步加载语言
            if (activeLng === i18next.resolvedLanguage) {
                return;
            }
            setActiveLng(i18next.resolvedLanguage);
        }, [activeLng, i18next.resolvedLanguage]);

        useEffect(() => {
            if (!lng || i18next.resolvedLanguage === lng) {
                return;
            }
            i18next.changeLanguage(lng);
        }, [lng, i18next]);
    }

    // 切换语言
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem('i18nextLng', lng);
    };

    // 获取当前语言
    const getCurrentLanguage = () => {
        return i18n.language;
    };

    // 检查是否为中文
    const isChinese = () => {
        return i18n.language === 'zh';
    };

    // 检查是否为英文
    const isEnglish = () => {
        return i18n.language === 'en';
    };

    // 切换命名空间
    const changeNamespace = (ns) => {
        i18n.changeLanguage(i18n.language, ns);
    };

    // 如果没有加载过命名空间，则加载
    return {
        ...useI18nTranslation(ns, options),
        lng,
        i18n: i18next,

        changeLanguage,
        getCurrentLanguage,
        isChinese,
        isEnglish,
        changeNamespace,
        language: i18n.language,
    }; //useTranslation(ns, options)
};

// export default useTranslation;

/**
 * 获取指定命名空间的 t 函数
 * @param {string} namespace - 命名空间（如 "common"）
 * @returns {Function} 绑定了该命名空间的 t 函数
 */
export const getT = async (ns: string | string[], lng: string, options = {}) => {
    // 如果没有设置语言，则使用默认语言
    if (lng && i18next.resolvedLanguage !== lng) {
        await i18next.changeLanguage(lng);
    }

    // 这里才是动态加载语言
    // 检查命名空间是否已加载，未加载则加载
    if (ns && (!i18next.hasLoadedNamespace(ns) || !i18next.hasResourceBundle(i18next.language, ns))) {
        await i18next.loadNamespaces(ns);
    }

    // // 返回一个新函数，自动携带命名空间参数
    // return (key: string, options = {}) => {
    //     // 合并用户传入的 options 和命名空间，命名空间优先级高
    //     return i18next.t(key, { ...options, ns })
    // }

    return {
        t: (key: string) => {
            // 合并用户传入的 options 和命名空间，命名空间优先级高
            return i18next.t(key, { ...options, ns });
        },
    };
};
export const getTSync = (ns: string | string[], lng: string, options = {}) => {
    // // 如果没有设置语言，则使用默认语言
    // if (lng && i18next.resolvedLanguage !== lng) {
    //     await i18next.changeLanguage(lng);
    // }

    // // 这里才是动态加载语言
    // // 检查命名空间是否已加载，未加载则加载
    // if (ns && (!i18next.hasLoadedNamespace(ns) || !i18next.hasResourceBundle(i18next.language, ns))) {
    //     await i18next.loadNamespaces(ns);
    // }

    // // 返回一个新函数，自动携带命名空间参数
    // return (key: string, options = {}) => {
    //     // 合并用户传入的 options 和命名空间，命名空间优先级高
    //     return i18next.t(key, { ...options, ns })
    // }

    return {
        t: (key: string) => {
            // 合并用户传入的 options 和命名空间，命名空间优先级高
            return i18next.t(key, { ...options, ns });
        },
    };
};

export { withTranslation };
